import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";

// About / brand info sections – purely presentational

function AboutUsPage() {
    const navigate = useNavigate();
    return (
        <Fragment>
            <div className='container-fluid m-t25'>
                <div className='row'>
                    <div className='col-12 cat-strip border shadow-sm'>
                        <div>
                            <button onClick={() => navigate(-1)}><IoMdArrowRoundBack /></button>
                            <label>ABOUT KIPPS</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='about-wrapper container-fluid px-0'>
                <section className='about-hero text-center'>
                    <div className='inner'>
                        <h1 className='about-title'>Crafting Sweet Moments Since 19XX</h1>
                        <p className='lead mb-0'>A trusted Bareilly name blending authentic taste, purity, and modern retail convenience.</p>
                    </div>
                </section>
                <section className='about-section container-lg px-3 px-sm-4 py-4 py-sm-5'>
                    <div className='row g-4'>
                        <div className='col-md-6'>
                            <h2 className='h5 section-heading'>Our Legacy</h2>
                            <p className='mb-2'>Kipps Sweets began as a humble mithai counter and has grown into a multi-location supermarket & confectionery destination in Bareilly. Consistency, hygiene, and honest flavours have helped us earn daily trust.</p>
                            <p className='mb-0'>From festive gifting to everyday essentials, we celebrate community taste and seasonal traditions.</p>
                        </div>
                        <div className='col-md-6'>
                            <h2 className='h5 section-heading'>What We Offer</h2>
                            <ul className='checked-list mb-0'>
                                <li>Fresh traditional sweets & dry fruits</li>
                                <li>Namkeens, baked snacks & festive hampers</li>
                                <li>Daily groceries & premium pantry essentials</li>
                                <li>Clean, quality-first preparation standards</li>
                                <li>Friendly in-store service & local trust</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className='about-highlight about-band bg-light-subtle py-4 py-sm-5'>
                    <div className='container-lg px-3 px-sm-4'>
                        <div className='row align-items-center gy-4'>
                            <div className='col-lg-7'>
                                <h2 className='h5 section-heading'>Our Promise</h2>
                                <p className='mb-2'>Every batch at Kipps reflects freshness, carefully sourced ingredients, and a respect for authentic recipes. We balance tradition with modern quality control so you can indulge confidently.</p>
                                <p className='mb-0'>If something isn't right, we make it right—because family tables deserve dependable taste.</p>
                            </div>
                            <div className='col-lg-5'>
                                <div className='info-cards d-grid gap-3'>
                                    <div className='mini-card'>
                                        <h3>Hygiene Focus</h3>
                                        <p>Sanitized prep areas & trained staff ensure consistent safety.</p>
                                    </div>
                                    <div className='mini-card'>
                                        <h3>Authentic Taste</h3>
                                        <p>Recipes preserved & refined for balanced sweetness.</p>
                                    </div>
                                    <div className='mini-card'>
                                        <h3>Community Roots</h3>
                                        <p>Serving Bareilly families across generations.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='about-values container-lg px-3 px-sm-4 py-4 py-sm-5'>
                    <div className='row g-4'>
                        <div className='col-12'>
                            <h2 className='h5 section-heading'>Core Values</h2>
                        </div>
                        <div className='col-sm-6 col-lg-3'>
                            <div className='value-tile'>
                                <h3>Trust</h3>
                                <p className='mb-0'>Consistency & transparent sourcing.</p>
                            </div>
                        </div>
                        <div className='col-sm-6 col-lg-3'>
                            <div className='value-tile'>
                                <h3>Freshness</h3>
                                <p className='mb-0'>Daily batches & careful handling.</p>
                            </div>
                        </div>
                        <div className='col-sm-6 col-lg-3'>
                            <div className='value-tile'>
                                <h3>Integrity</h3>
                                <p className='mb-0'>Quality over shortcuts—always.</p>
                            </div>
                        </div>
                        <div className='col-sm-6 col-lg-3'>
                            <div className='value-tile'>
                                <h3>Care</h3>
                                <p className='mb-0'>Hospitality & personal attention.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='about-cta-band text-center py-5'>
                    <div className='container-lg px-3 px-sm-4'>
                        <h2 className='h5 mb-3'>Visit A Kipps Store Today</h2>
                        <p className='mb-4'>Discover why generations rely on us for festive treats, everyday freshness, and memorable gifting.</p>
                        <button type='button' className='prod-button ghost' onClick={() => navigate(-1)}>GO BACK</button>
                    </div>
                </section>
            </div>
            <div className='pt-4 mb-5 mt-5'></div>
        </Fragment>
    )
}

export default AboutUsPage;
